(function (sb) {
	var byValAsc = 2, byValDesc = 1, otherChart = 7;

	var o = {
		axis: {
			key: 'axis', sortKey: 'axisSortKey',
			dropdown: '',
			prop: 'axisSort',
			valueSortDropdown: ''
		},
		legend: {
			key: 'legend', sortKey: 'legendSortKey',
			dropdown: '',
			prop: 'legendSort',
			valueSortDropdown: ''
		}
	};

	var me = sb.FilterSort = (sb.FilterSort || {});

	function resetDropdownIds() {
		if (o['axis'].dropdown == '') {
			o['axis'].dropdown = window.ContentType == Storyboard.Constants.itemTypes.CHART ? '#ddlAxisSort_cc' : '#ddlAxisSort';
			o['legend'].dropdown = window.ContentType == Storyboard.Constants.itemTypes.CHART ? '#ddlLegendSort_cc' : '#ddlLegendSort';
			o['axis'].valueSortDropdown = window.ContentType == Storyboard.Constants.itemTypes.CHART ? '#ddlAxisAuxSortingValue_cc' : '#ddlAxisAuxSortingValue';
			o['legend'].valueSortDropdown = window.ContentType == Storyboard.Constants.itemTypes.CHART ? '#ddlLegendAuxSortingValue_cc' : '#ddlLegendAuxSortingValue';
		}
	}

	function unsetValue(jqDDL, val) {
		if ($(jqDDL).val() == val)
			$(jqDDL).val(0);
	}

	me.updateSort = function (groupingItem, manualRecalculate) {
		resetDropdownIds();

		var direction = groupingItem.position == "1" ? "axis" : "legend";
		var selAxis = o[direction];
		var selValueSortSeries = $(o[direction].valueSortDropdown).val();
		var foreignDataGroupId = $(o["axis"].dropdown).val() == otherChart ? $(o["axis"].valueSortDropdown).val() : 0;
		applySelections($(selAxis.dropdown).val(), direction, foreignDataGroupId, selValueSortSeries, null, window.ContentType == Storyboard.Constants.itemTypes.CHART, false, manualRecalculate);
		if (window.ContentType == Storyboard.Constants.itemTypes.CHART)
			ChartCreatorUI.showHideSortingControls();
	};

	function fetchCombinationsForAxis(axisObj, defaultSelection, datagroup, autoRecalculate, manualRecalculate) {
		var isChartCreator = window.ContentType > 0 && window.ContentType === Storyboard.Constants.itemTypes.CHART;
		var opposite = o[getOpp(axisObj.key)];
		/* load and show "by val" selections for the selected axis */
		var dataGroup = isChartCreator ? ChartCreatorUIObj.GetDatagroupFromGui() : ChartSetupUIObj.GetDatagroupFromGui();
		var data = { dataGroup: dataGroup, type: opposite.key, chartCreator: isChartCreator, forSorting: true };

		$("#DUI-ST-SAVESETTINGS, #btnUpdateChart").attr("disabled", "disabled");

		if (isChartCreator) {
			ChartCreatorSetup.disableContentEditing();
			ChartCreatorUI.enableDisableCalculateButton(false);
		}

		Helpers.perfJSonCall({
			method: 'GetGroupingCombinationsForDataGroup',
			data: data,
			fixCasing: true,
			message: 'Loading series info',
			service: 'chartsetup',
			successCallback: function (combinations) { refreshCombinationsForAxis(axisObj, defaultSelection, dataGroup, autoRecalculate, combinations, manualRecalculate); },
			failCallback: function () {
				$("#DUI-ST-SAVESETTINGS, #btnUpdateChart").removeAttr("disabled");
				if (isChartCreator) {
					ChartCreatorSetup.enableContentEditing();
				}
			}
		});
	}

	function fetchSelectedSortOption(axisObj, defaultSelection, dataGroup, autoRecalculate, selectedSortValue) {
		if (!selectedSortValue || selectedSortValue === '0' || selectedSortValue === '0##') {
			refreshCombinationsForAxis(axisObj, defaultSelection, dataGroup, autoRecalculate, []);
			return;
		}

		Helpers.perfJSonCall({
			method: 'GetSelectedValueSortOption',
			data: { selectedValueSort: selectedSortValue },
			fixCasing: true,
			message: 'Loading sort info',
			service: 'chartsetup',
			successCallback: function (combinations) { refreshCombinationsForAxis(axisObj, defaultSelection, dataGroup, autoRecalculate, combinations); },
			failCallback: function () { $("#DUI-ST-SAVESETTINGS, #btnUpdateChart").removeAttr("disabled"); }
		});
	}

	function refreshCombinationsForAxis(axisObj, defaultSelection, dataGroup, autoRecalculate, combinations, manualRecalculate) {
		var isChartCreator = window.ContentType > 0 && window.ContentType === Storyboard.Constants.itemTypes.CHART;

		$("#DUI-ST-SAVESETTINGS, #btnUpdateChart").removeAttr("disabled");
		if (combinations.length == 1 && combinations[0].value == '')
			combinations[0].text = '[No series]';

		var noSelection = isChartCreator ? '' : (defaultSelection == "0" ? 'Not selected' : null);
		HTMLHelpers.bindSelect(axisObj.valueSortDropdown, combinations, 'value', 'text', noSelection);

		if ($(axisObj.valueSortDropdown).find('option[value="series:last"]').length > 0 && $(axisObj.valueSortDropdown).find('option[value="series:first"]').length > 0)
			$(axisObj.valueSortDropdown).find('option[value="series:last"]').after($('<option disabled>──────────</option>'));

		if (window.ContentType !== Storyboard.Constants.itemTypes.CHART || combinations.length > 1) {
			$(axisObj.valueSortDropdown).show();
			$("div[for='" + axisObj.valueSortDropdown + "']").show();
		} else {
			$(axisObj.valueSortDropdown).hide();
			$("div[for='" + axisObj.valueSortDropdown + "']").hide();
		}

		if (isChartCreator && combinations.length == 1) {
			$(axisObj.valueSortDropdown).val(combinations[0].value);
		}

		if (defaultSelection)
			$(axisObj.valueSortDropdown).val(defaultSelection);

		if (isChartCreator) {
			ChartCreatorSetup.enableContentEditing();

			if (manualRecalculate)
				ChartCreatorSetup.controlForManualRecalculateChanged();
			else if (autoRecalculate && dataGroup.guid)
				ChartCreatorSetup.controlForAutoRecalculateChanged();
		}
	}

	function fetchCompatibleDataGroupsForAxis(axisObj, defaultSelection) {
		var dataGroup = window.ContentType == Storyboard.Constants.itemTypes.CHART ? ChartCreatorUIObj.GetDatagroupFromGui() : ChartSetupUIObj.GetDatagroupFromGui();
		var data = { dataGroup: dataGroup };
		var service = 'chartsetup';
		if (window.ContentType && window.ContentType == Storyboard.Constants.itemTypes.CHART) {
			service = 'chartcreatorsetup';
			data.layout = Storyboard.LayoutDesigner.getLayoutGrid();
		}

		Helpers.perfJSonCall({
			method: 'GetCompatibleDataGroupsForAxis',
			data: data,
			fixCasing: true,
			message: 'Loading chart list',
			service: service,
			successCallback: function (dataGroups) {
				if (dataGroups.length) {
					HTMLHelpers.bindSelect(axisObj.valueSortDropdown, dataGroups, 'value', 'text', false);
					$(axisObj.valueSortDropdown).show();
					$("div[for='" + axisObj.valueSortDropdown + "']").show();
					if (defaultSelection)
						$(axisObj.valueSortDropdown).val(defaultSelection);
				}
				else {
					$(axisObj.valueSortDropdown).hide();
					$("div[for='" + axisObj.valueSortDropdown + "']").hide();
				}
			}
		});

	}

	function getOpp(dir) {
		return dir === 'axis' ? 'legend' : 'axis';
	}

	me.reloadCharts = function (foreignDataGroupId) {
		resetDropdownIds();
		fetchCompatibleDataGroupsForAxis(o.axis, foreignDataGroupId || '');
	};

	me.getSelections = function () {
		resetDropdownIds();

		var axisSortValues = $(o["axis"].valueSortDropdown).val() || '';
		var legendSortValues = $(o["legend"].valueSortDropdown).val() || '';

		return {
			axis: {
				sort: $(o['axis'].dropdown).val(),
				sortValues: axisSortValues.split('##'),
				foreignDataGroupId: $(o['axis'].dropdown).val() == otherChart ? $(o["axis"].valueSortDropdown).val() : null
			},
			legend: {
				sort: $(o['legend'].dropdown).val(),
				sortValues: legendSortValues.split('##')
			}
		};
	};

	me.setSelections = function (datagroup, useLazyLoad) {
		resetDropdownIds();

		for (var dir in o)
			if (o.hasOwnProperty(dir)) {

				var d = o[dir];
				HTMLHelpers.setSelectedValues(d.dropdown, datagroup.sortingInfo[d.prop] || 0);
				$(d.valueSortDropdown).hide().children().remove();
				$("div[for='" + d.valueSortDropdown + "']").hide();

				var selValueSortSeries = datagroup.sortingInfo[d.sortKey];
				if (selValueSortSeries !== null && selValueSortSeries !== "" && selValueSortSeries !== undefined && (selValueSortSeries.includes("series:first") || selValueSortSeries.includes("series:last"))) {
					selValueSortSeries = selValueSortSeries.replace("##", "");
                }
				var sortType = datagroup.sortingInfo[d.prop];

				applySelections(sortType, dir, datagroup.sortingInfo.foreignDataGroupId, selValueSortSeries, datagroup, false, useLazyLoad);
			}

		$(o['axis'].dropdown + ", " + o['legend'].dropdown).unbind('change').bind('change', function () {
			var selAxis = o[$(this).data("direction")];
			var selValueSortSeries = $(o[$(this).data("direction")].valueSortDropdown).val();
			applySelections($(selAxis.dropdown).val(), $(this).data("direction"), 0, selValueSortSeries, null, true);

		});

		$(".btnSortingValue").attr('src', 'icons/update.png');
		$(".btnSortingValue").unbind('click').bind('click', function () {
			var selAxis = o[$(this).data("direction")];
			var selValueSortSeries = $(o[$(this).data("direction")].valueSortDropdown).val();
			applySelections($(selAxis.dropdown).val(), $(this).data("direction"), 0, selValueSortSeries);

		});
	};

	function applySelections(selSortValue, direction, foreignDataGroupId, selValueSortSeries, datagroup, autoRecalculate, useLazyLoad, manualRecalculate) {
		var selAxis = o[direction];
		var opposite = o[getOpp(direction)];

		if (selSortValue == byValAsc || selSortValue == byValDesc) {
			unsetValue(opposite.dropdown, byValAsc);
			unsetValue(opposite.dropdown, byValDesc);
			$(opposite.valueSortDropdown).hide().children().remove();
			$("div[for='" + opposite.valueSortDropdown + "']").hide();

			$(".btnSortingValue").hide();
			$(".btnSortingValue[data-direction=" + selAxis.key + "]").show();

			if (useLazyLoad)
				// load only selected sort value
				fetchSelectedSortOption(o[direction], selValueSortSeries, datagroup, autoRecalculate, selValueSortSeries);
			else
				fetchCombinationsForAxis(o[direction], selValueSortSeries, datagroup, autoRecalculate, manualRecalculate);
		}
		else {
			$(".btnSortingValue[data-direction=" + selAxis.key + "]").hide();
			$(selAxis.valueSortDropdown).hide().children().remove();
			$("div[for='" + selAxis.valueSortDropdown + "']").hide();

			if (window.ContentType == Storyboard.Constants.itemTypes.CHART && manualRecalculate !== false) {
				if (manualRecalculate)
					ChartCreatorSetup.controlForManualRecalculateChanged();
				else if (autoRecalculate)
					ChartCreatorSetup.controlForAutoRecalculateChanged();
			}
		}

		if (selAxis.key === 'axis' && $(selAxis.dropdown).val() == otherChart) {
			fetchCompatibleDataGroupsForAxis(selAxis, foreignDataGroupId || '');
		}
	}


})(window.Storyboard = (window.Storyboard || {}));